function render(props) {
  if (typeof props.children === 'function') {
    return props.children(props);
  }
  return props.children || null;
}
export function When(_ref) {
  var condition = _ref.condition,
    children = _ref.children,
    _ref$else = _ref.else,
    elseNode = _ref$else === void 0 ? null : _ref$else;
  return condition ? render({
    condition: condition,
    children: children
  }) : elseNode;
}